<template>
  <dialog-v2
    :show="show"
    :title="title"
    max-width="600px"
    @close="$emit('close')"
    @save="save">
    <template v-if="stage.id" slot="title">
      <v-icon class="delete-icon" @click.stop="deleteStage(stage)" color="red" small>fas fa-trash-alt</v-icon>
    </template>
    <template slot="content">
      <v-layout row wrap>
        <v-flex md10 pr-4>
          <v-text-field
            v-model="form.name"
            v-validate="'required|max:100'"
            data-vv-name="name"
            data-vv-scope="stage"
            data-vv-as="nombre"
            :error-messages="errors.collect('stage.name')"
            label="Nombre"
            color="black"/>
        </v-flex>
        <v-flex md2>
          <v-text-field
            v-model.number="form.order"
            v-validate="`required|integer|min_value:1|max_value:${maxOrder}`"
            data-vv-name="order"
            data-vv-scope="stage"
            data-vv-as="order"
            :error-messages="errors.collect('stage.order')"
            label="Orden"
            color="black"/>
          </v-flex>
      </v-layout>
      <v-layout row wrap mb-3>
        <v-flex md12>
          <v-select
            v-model="form.type_id"
            :items="types"
            item-value="id"
            item-text="label"
            v-validate="'required'"
            data-vv-scope="stage"
            data-vv-name="type_id"
            data-vv-as="Tipo"
            :error-messages="errors.collect('stage.type_id')"
            label="Tipo"
            color="black">
          </v-select>
        </v-flex>
      </v-layout>
      <v-layout v-if="form.type_id === 1" row wrap>
        <v-flex md4>
          <v-checkbox
            label="Forzar primera gestion"
            class="mt-2 k-orange-linear-text force-check"
            v-model="form.force_first_notification">
          </v-checkbox>
        </v-flex>
      </v-layout>
      <v-layout v-if="global" row wrap>
        <v-flex md4>
          <v-switch
            label="Global"
            v-model="global"
            class="k-blue-linear-text"
            :hide-details="true"
            disabled>
          </v-switch>
        </v-flex>
      </v-layout>
      <filters-list
        v-model="form.stage_filters"
        :default-filters="form.stage_filters" :key="filtersListKey"/>
    </template>
  </dialog-v2>
</template>

<script>
import _ from 'lodash';
import DialogV2 from '@/components/global/DialogV2';
import FiltersList from '@/components/global/CustomerFilters/Index';

const uuidv1 = require('uuid/v1');

export default {
  inject: ['$validator'],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    global: {
      type: Boolean,
      default: false,
    },
    stage: {
      type: Object,
      required: false,
    },
    maxOrder: {
      type: Number,
      required: true,
    },
  },
  components: {
    DialogV2,
    FiltersList,
  },
  data() {
    const emptyForm = {
      name: '',
      order: '',
      force_first_notification: false,
      stage_filters: {
        type: 'group',
        operator: 'and',
        items: [],
      },
      type_id: '',
    };
    return {
      filtersListKey: uuidv1(),
      emptyForm,
      form: {
        ..._.cloneDeep(emptyForm),
      },
      types: [
        {
          id: 1,
          label: 'Cobranza',
        },
        {
          id: 2,
          label: 'Informativo',
        },
      ],
    };
  },
  computed: {
    title() {
      return `${!Object.keys(this.stage).length ? 'Crear' : 'Editar'} segmento ${this.global ? 'global' : 'normal'}`;
    },
  },
  methods: {
    deleteStage(stage) {
      this.$emit('delete-stage', stage);
    },
    clearErrors() {
      Object.keys(this.form).forEach((key) => {
        this.$validator.errors.remove(key, 'stage');
      });
    },
    save() {
      this.$validator.validateAll('stage').then((validation) => {
        if(validation) {
          if (Object.keys(this.stage).length) {
            this.axios.patch(`stages/${this.stage.id}`, {
              ..._.omit(this.form, 'stage_filters'),
              stage_filters: JSON.stringify(this.form.stage_filters),
            })
              .then((response) => {
                this.$emit('updated', response.data);
                this.$emit('close');
              });
          } else {
            this.axios.post(`workflows/${this.$route.params.workflow}/stages`, {
              ..._.omit(this.form, 'stage_filters'),
              stage_filters: JSON.stringify(this.form.stage_filters),
              global: this.global ? 1 : 0,
            })
              .then((response) => {
                this.$emit('created', {
                  ...response.data,
                });
                this.$emit('close');
              })
              .catch(() => {});
          }
        }
      })
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.form = _.pick({
          ..._.cloneDeep(this.emptyForm),
          order: this.maxOrder,
          ...this.stage,
        }, Object.keys(this.emptyForm));
        if(typeof this.form.stage_filters === 'string') {
          this.form.stage_filters = JSON.parse(this.form.stage_filters);
        }
        this.clearErrors();
      } else {
        setTimeout(() => {
          this.form = {
            ..._.cloneDeep(this.emptyForm),
            order: this.maxOrder,
          };
          this.clearErrors();
        }, 200);
      }
      this.filtersListKey = uuidv1();
    },
    'form.type_id' (value) {
      if (value !== 1) {
        this.form.force_first_notification = false;
      }
    },
  },
};
</script>

<style scoped>
  .force-check >>> label {
    max-width: 100% !important;
  }
  .delete-icon:hover {
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/components/V2CollectWorkflows/Detail/WorkflowTree/StageModal.vue